/* eslint-disable */
import React from 'react';
import cn from 'classnames';
import { TreeView, TreeItem } from '@material-ui/lab';
import { useStylesTreeView, useStylesTreeitem } from './styles';
import { useHierarchicalSelector } from './useHierarchicalSelector';
import Input from './Input';
import Search from './Search';
import Popover from './Popover';
import AddBoxOutlinedIcon from '../../../../icons/OpenTree';
import { cloneDeep } from 'lodash';
import RemoveOutlinedIcon from '../../../../icons/CloseTree';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { hierarchyAllByChildId, hierarchies, Hierarchy } from '../../../bulkexport';

const useTreeStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '3px',
    },
  },
  box: {
    overflow: 'hidden',
  }
}));
const useParentStyles = makeStyles((theme: Theme) => createStyles({
  root: {

    "& $content:hover": {
      background: "rgba(51, 51, 51, 0.05)",
    }
  },
  selected: {
    "& > $content": {
      background: "rgba(101, 172, 30, 0.2)",

      "& > $label": {
        background: "none !important",
        color: "#65AC1E",
      }
    },
  },
  content: {
    borderRadius: "4px",
    padding: "6px",
    height: '32px',
  },
  label: {
    color: "rgba(39, 58, 57, 0.8)",
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: "bold",
    background: "none !important",
  }
}));

const useItemStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    marginBottom: '2px',
    "& $content:hover": {
      background: "rgba(51, 51, 51, 0.05)",
    }
  },
  content: {
    borderRadius: "4px",
    padding: "6px",
    height: '32px',
  },
  label: {
    color: "rgba(39, 58, 57, 0.8)",
    fontSize: "12px",
    lineHeight: "100%",
    fontWeight: "bold",
    background: "none !important",
  },
  selected: {
    "& $content": {
      background: "rgba(101, 172, 30, 0.2)",

    },
    "& $label": {
      background: "none !important",
      color: "#65AC1E",
    }
  },
}));
const mockitems = [{
  id: '1',
  name: 'Item1'
}, {
  id: '2',
  name: 'Item2'
}, {
  id: '3',
  name: 'Item1_1',
  parent: '1'
}, {
  id: '4',
  name: 'Item1_1',
  parent: '1'
}, {
  id: '5',
  name: 'Item2_1',
  parent: '2'

},];

export const Commodities: React.FC<any> = props => {
  const { search, handleSearch } = useHierarchicalSelector();
  const items: any[] = props.items || mockitems;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classesItem = useItemStyles();
  const classesParent = useParentStyles();
  const propsValue = props.value;
  const [checked, setChecked] = React.useState<string[]>(propsValue || []);
  const { label = "Commodities", multiple = false, large = false } = props;


  React.useEffect(() => {
    if (propsValue?.length && JSON.stringify(propsValue) !== JSON.stringify(checked)) {
      setChecked(propsValue);
    }
  }, [JSON.stringify(propsValue)]);

  React.useEffect(() => {
    if (props.onChange && !multiple) {
      props.onChange(checked);
    }
  }, [JSON.stringify(checked)]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
      const selectedItem = document.querySelector('.tree-view [aria-selected="true"]');
      try {
        // For IE. block start
        selectedItem?.scrollIntoView();
        // For NO IE. block center
        selectedItem?.scrollIntoView({
          block: 'end',
        });
      } catch (e) {

      }
    }, 100);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (props.onChange && multiple) {
      props.onChange(checked);
    }
  };

  const treeViewClasses = useTreeStyles();
  const nodes = React.useMemo(() => hierarchies<any>(items.filter(x => !search || x.name.trim().toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())), "id", "parent"), [items, search]);
  const openedNodes = React.useMemo(() => hierarchyAllByChildId(nodes, checked[0]), [nodes, checked]);
  const open = Boolean(anchorEl);
  const togglePopover = e => open ? handleClose() : handleClick(e);
  const handleToggle = (e, id) => {
    if (!e.target.classList.contains('tree-parent-toggle') && !e.target.closest('.tree-parent-toggle')) {
      const checkedItem = items.find(item => item.id === id);
      if (!checkedItem?.disabled) {
        if (!multiple) {
          const newChecked = [id];
          setChecked(newChecked);
          handleClose();
        } else {
          id = id[0];
          const newChecked = checked.includes(id) ? checked.filter(x => x !== id) : [id, ...checked];
          setChecked(newChecked);
        }
      }
    }
  };

  const customNode = (hierarchy: Hierarchy<any>) => {
    if (hierarchy.children.length) {
      return (<TreeItem role="listitem" key={hierarchy.item.name} nodeId={hierarchy.id} label={hierarchy.item.name} className="tree-parentnode"
        classes={classesParent}
      >
        {hierarchy.children.map(customNode)}
      </TreeItem>);
    }
    return (<TreeItem role="listitem" key={hierarchy.item.name} nodeId={hierarchy.id} label={hierarchy.item.name} className="tree-node"
      classes={classesItem}
    />);
  }

  const inputDisplayValue = checked.length === 1 ?
    items.find(x => x.id === checked[0])?.name
    : `${checked.length} of ${items.length}`;

  return <>
    <Input label={label} value={inputDisplayValue} open={open} onClick={togglePopover} />
    <Popover large={large} anchorEl={anchorEl} onClose={togglePopover}>
      <Search onChange={handleSearch} />
      {(
        <div className={cn(treeViewClasses.box, "tree-view")}>
          <TreeView
            defaultCollapseIcon={<RemoveOutlinedIcon className="tree-parent-toggle" />}
            defaultExpandIcon={<AddBoxOutlinedIcon className="tree-parent-toggle" />}
            role="list"
            className={treeViewClasses.root}
            defaultExpanded={(search ? nodes : openedNodes).map(x => x.id)}
            // expanded={Boolean(props.search) ? nodes.map(x => x.id) : undefined}
            selected={(multiple ? checked : checked[0]) as any}
            multiSelect={multiple}
            onNodeSelect={handleToggle}
          >
            {!nodes?.length && '' ? "No results" : null}
            {nodes.map(customNode)}
          </TreeView>
        </div>
      )}
    </Popover>
  </>;
}